<template>
    <div class="main-content">
        <the-header :title="t('Translator')"/>
        <nav-body :links="nav">
            <manage-template
                    :id="$route.params.id"
                    :type="$route.params.type"
                    :createNew="$route.name === 'adminCreateTemplateList'"
                    :disabled-identifier="$route.name !== 'adminCreateTemplateList'"
                    :visible-identifier="showIdentifier"
                    :textInputType="textInputType"
                    @saved="$router.push({name: 'adminTemplateList', params: {page: 1}})"
            />
        </nav-body>
    </div>
</template>
<script>
    import ManageTemplate from '../../../../admin/Pages/Templates/Manage';
    import TheHeader from '../../../../admin/Layout/TheHeader'
    import NavBody from '../../../../admin/Layout/NavBody'
    import {admin} from '../Admin'

    export default {
        mixins: [admin],
        components: {
            TheHeader,
            NavBody,
            ManageTemplate
        },
        computed: {
            textInputType() {
                return this.$route.params.type === 'patientTextMessages' ? 'textArea' : 'titanRedactor';
            },
            showIdentifier() {
                return !['patientTextMessages', 'patientMail'].includes(this.$route.params.type);
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/pages/private/admin/template/Manage.vue